import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import moment from 'logic/moment';

const styles = makeStyles({
  btn: {
    marginBottom: '8px',
  },
});

const OverlapWarning = ({ overlap, onAccept, onCancel }) => {
  const classes = styles();

  if (!overlap || !overlap.length) {
    return null;
  }

  return (
    <>
      <Alert severity="warning" elevation={3}>
        <FormattedMessage
          id="booking.overlap"
          defaultMessage="Warning, there is already one or more bookings overlapping with the selected check in / check out dates"
        />
        {overlap.map((ol) => (
          <Typography key={ol.id} variant="body2">
            <Link
              to={`/conversations/${ol.conversation_id}/bookings/${ol.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage
                id="booking.overlap.detail"
                defaultMessage="Booking #{id} - Check-in: {checkin} | Check-out: {checkout}"
                values={{
                  id: ol.id,
                  checkin: moment(ol.check_in).format('LLLL'),
                  checkout: moment(ol.check_out).format('LLLL'),
                }}
              />
            </Link>
          </Typography>
        ))}
      </Alert>
      {(onAccept || onCancel) && (
        <Box textAlign="center" py={2}>
          {onAccept && (
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={onAccept}
              className={classes.btn}
            >
              <FormattedMessage
                id="booking.overlap.understand"
                defaultMessage="I understand, continue anyway"
              />
            </Button>
          )}
          {onAccept && onCancel && <>&nbsp;</>}
          {onCancel && (
            <Button
              type="button"
              variant="contained"
              color="secondary"
              onClick={onCancel}
              className={classes.btn}
            >
              <FormattedMessage id="Back" defaultMessage="Back" />
            </Button>
          )}
        </Box>
      )}
    </>
  );
};

OverlapWarning.propTypes = {
  overlap: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      conversation_id: PropTypes.number,
      check_in: PropTypes.string,
      check_out: PropTypes.string,
    }),
  ),
  onAccept: PropTypes.func,
  onCancel: PropTypes.func,
};

export default OverlapWarning;
